/**
 * Extract lat/lng from common Google Maps URL shapes.
 * Returns { latitude, longitude, location_url } or null if unrecognized.
 */
export function parseGoogleMapsLink(raw) {
  const input = String(raw || '').trim();
  if (!input) return null;

  const location_url = input;
  let latitude = null;
  let longitude = null;

  // @24.7136,46.6753,17z or @24.7136,46.6753
  let m = input.match(/@(-?\d+\.?\d*),\s*(-?\d+\.?\d*)/);
  if (m) {
    latitude = parseFloat(m[1]);
    longitude = parseFloat(m[2]);
  }

  // ?q=24.7136,46.6753 or query=24.7136,46.6753
  if (latitude == null) {
    m = input.match(/[?&](?:q|query)=(-?\d+\.?\d*)\s*,\s*(-?\d+\.?\d*)/i);
    if (m) {
      latitude = parseFloat(m[1]);
      longitude = parseFloat(m[2]);
    }
  }

  // !3dLAT!4dLNG (place data)
  if (latitude == null) {
    m = input.match(/!3d(-?\d+\.?\d*)!4d(-?\d+\.?\d*)/);
    if (m) {
      latitude = parseFloat(m[1]);
      longitude = parseFloat(m[2]);
    }
  }

  // Plain "24.7136, 46.6753"
  if (latitude == null) {
    m = input.match(/^(-?\d+\.?\d*)\s*,\s*(-?\d+\.?\d*)$/);
    if (m) {
      latitude = parseFloat(m[1]);
      longitude = parseFloat(m[2]);
    }
  }

  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    // Still store the URL (e.g. maps.app.goo.gl short links) even without coords
    if (/google\.|maps\.app\.goo\.gl|goo\.gl\/maps/i.test(input)) {
      return { latitude: null, longitude: null, location_url };
    }
    return null;
  }

  return { latitude, longitude, location_url };
}
